import r from "./OrderCycle.ce.vue2.js";
import o from "./OrderCycle.ce.vue3.js";
import t from "../../_virtual/_plugin-vue_export-helper.js";
const f = /* @__PURE__ */ t(r, [["styles", [o]]]);
export {
  f as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/order-cycle/OrderCycle.ce.vue.js
// module id = 1269
// module chunks = 41